export function extractExistingParams(searchParams: URLSearchParams): Record<string, string[]> {
  const entries = Array.from(searchParams.entries());
  return entries.reduce((acc: Record<string, string[]>, a: [string, string]) => {
    (acc[a[0]] = acc[a[0]] || []).push(a[1]);
    return acc;
  }, {});
}

export function augmentExistingParams(searchParams: URLSearchParams, key: string, value: string): Record<string, string[]> {
  const existingParams = extractExistingParams(searchParams);
  existingParams[key] = existingParams[key] || [];
  existingParams[key].push(value);
  return existingParams;
}

export function replaceExistingParamsValue(searchParams: URLSearchParams, key: string, value: string | string[]): Record<string, string[]> {
  const existingParams = extractExistingParams(searchParams);
  if (!value || (Array.isArray(value) && value.length === 0)) {
    delete existingParams[key];
  } else if (Array.isArray(value)) {
    existingParams[key] = value;
  } else {
    existingParams[key] = [value];
  }
  return existingParams;
}

export function removeExistingParamsArrayValue(searchParams: URLSearchParams, key: string, value: string): Record<string, string[]> {
  const existingParams = extractExistingParams(searchParams);
  if (existingParams[key]) {
    existingParams[key] = existingParams[key].filter(v => v !== value);
    if (existingParams[key].length === 0) {
      delete existingParams[key];
    }
  }
  return existingParams;
}

export function removeExistingParam(searchParams: URLSearchParams, key: string): Record<string, string[]> {
  const existingParams = extractExistingParams(searchParams);
  delete existingParams[key];
  return existingParams;
}
